import _groupBy from 'lodash/groupBy';
import _get from 'lodash/get';
import _omit from 'lodash/omit';
import * as MappingTypes from 'types/Mapping';
import {
  ORG_TEAM_LEADER_MAPPING_MATCH_KEY,
  ORG_TEAM_LEADER_MAPPING_REF_KEY,
  ORG_MAPPING_TYPE_KEY,
} from 'pages/Directory/consts';

function getValidatedMappingCards(
  mappingCards: MappingTypes.MappingCardData[],
  validationResults: MappingTypes.MappingValidationResult[],
) {
  const rowValidationResults = validationResults.filter((vr: any) => !!vr.mapping);

  const validationResultsLookup = _groupBy(rowValidationResults, vr =>
    _get(vr, ['mapping', '_referenceId']),
  );

  const orgMappingValidationResults = rowValidationResults.filter(vr =>
    [ORG_TEAM_LEADER_MAPPING_MATCH_KEY, ORG_TEAM_LEADER_MAPPING_REF_KEY].includes(
      _get(vr, ['mapping', 'destination']),
    ),
  );
  const orgValidationLookup = _groupBy(orgMappingValidationResults, vr =>
    _get(vr, ['mapping', 'destination']),
  );

  return mappingCards.map(section => {
    if (!section.mappings) {
      return section;
    }

    if (section.type === ORG_MAPPING_TYPE_KEY) {
      if (!orgMappingValidationResults.length) {
        return {
          ...section,
          mappings: section.mappings.map(m => {
            return _omit(m, 'validation');
          }),
        };
      }

      return {
        ...section,
        mappings: section.mappings.map(m => {
          const lookupKey = _get(m, 'destination');
          const validation = orgValidationLookup[lookupKey];

          if (!validation) {
            return _omit(m, 'validation');
          }

          if (validation.length > 1) {
            return {
              ...m,
              validation: `${validation.length} issues found, see Mappings Summary for detail`,
            };
          }

          return { ...m, validation: validation[0] };
        }),
      };
    }

    return {
      ...section,
      mappings: section.mappings.map(m => {
        const _referenceId = _get(m, '_referenceId') || '';
        const validation = validationResultsLookup[_referenceId];

        if (!validation) {
          return _omit(m, 'validation');
        }

        if (validation.length > 1) {
          return {
            ...m,
            validation: {
              type: validation.some(v => v.type === 'error') ? 'error' : 'warning',
              longDescriptionHtml: `${validation.length} issues found, see Mappings Summary for detail`,
              descriptionHtml: `${validation.length} issues found, see Mappings Summary for detail`,
            },
          };
        }

        return { ...m, validation: validation[0] };
      }),
    };
  });
}

export default getValidatedMappingCards;
